export function maskUsername(username: string): string {
  if (!username) {
    return '';
  }
  const len = username.length;
  if (len <= 1) {
    return username;
  }
  if (len === 2) {
    return username.substring(0, 1) + '*';
  }
  if (len === 3) {
    return username.substring(0, 1) + '*' + username.substring(len - 1);
  }
  if (len === 4) {
    return username.substring(0, 1) + '**' + username.substring(len - 1);
  }
  if (len === 5 || len === 6) {
    return username.substring(0, 2) + '***' + username.substring(len - 1);
  }
  // length > 6
  return username.replace(/(.{3}).{4}(.*)/, '$1****$2');
}